import { getData, postData } from "../../../common/utils/network.utils";

export const getReports = async () => {
  return (await getData(`reports`)).data;
}

export const getReportByType = async (data) => {
  return (await postData(`reports/request`, data));
}